import { RegionOfInterest } from 'features/fde/regionTypes'

export function rulerToRegion(ruler: Ruler): RegionOfInterest {
  return {
    id: ruler.id,
    title: ruler.title,
    selection: ruler.selection,
  }
}

// These are the same at the moment - swap this out if it changes
export type Ruler = RegionOfInterest & { wraps?: ('x' | 'y')[] }
